/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for /start-with-booking-id-and-surname endpoint
 * @export
 * @interface PaxCheckStartWithBookingIdAndSurnameResponseData
 */
export interface PaxCheckStartWithBookingIdAndSurnameResponseData {
    /**
     * MultiPax session id
     * @type {string}
     * @memberof PaxCheckStartWithBookingIdAndSurnameResponseData
     */
    sessionId: string;
    /**
     * Session token to authenticate to other API endpoints
     * @type {string}
     * @memberof PaxCheckStartWithBookingIdAndSurnameResponseData
     */
    paxCheckToken: string;
    /**
     * URL to where navigate passenger to
     * @type {string}
     * @memberof PaxCheckStartWithBookingIdAndSurnameResponseData
     */
    returnUrl?: string | null;
}

/**
 * Check if a given object implements the PaxCheckStartWithBookingIdAndSurnameResponseData interface.
 */
export function instanceOfPaxCheckStartWithBookingIdAndSurnameResponseData(value: object): value is PaxCheckStartWithBookingIdAndSurnameResponseData {
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('paxCheckToken' in value) || value['paxCheckToken'] === undefined) return false;
    return true;
}

export function PaxCheckStartWithBookingIdAndSurnameResponseDataFromJSON(json: any): PaxCheckStartWithBookingIdAndSurnameResponseData {
    return PaxCheckStartWithBookingIdAndSurnameResponseDataFromJSONTyped(json, false);
}

export function PaxCheckStartWithBookingIdAndSurnameResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckStartWithBookingIdAndSurnameResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['session_id'],
        'paxCheckToken': json['pax_check_token'],
        'returnUrl': json['return_url'] == null ? undefined : json['return_url'],
    };
}

export function PaxCheckStartWithBookingIdAndSurnameResponseDataToJSON(json: any): PaxCheckStartWithBookingIdAndSurnameResponseData {
    return PaxCheckStartWithBookingIdAndSurnameResponseDataToJSONTyped(json, false);
}

export function PaxCheckStartWithBookingIdAndSurnameResponseDataToJSONTyped(value?: PaxCheckStartWithBookingIdAndSurnameResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_id': value['sessionId'],
        'pax_check_token': value['paxCheckToken'],
        'return_url': value['returnUrl'],
    };
}

